import { useSearch } from '@tanstack/react-router';
import { TaskReviewBody } from './TaskReviewBody';

/**
 * Full-page task review: header chrome (meta + toolbar) + body + timeline.
 * Assignee, type actions, and close live in the header — not as stacked cards.
 */
export function TaskReviewView({ taskId }: { taskId: string }) {
  const { fromPage, chat } = useSearch({
    from: '/authenticated/tasks/$taskId',
  });
  return (
    <TaskReviewBody
      taskId={taskId}
      fromPage={fromPage}
      layout="page"
      openChat={chat === 'open'}
    />
  );
}
